import { css, FlattenInterpolation, ThemeProps } from 'styled-components';
import { boxShadow } from '../../commonStyles/boxStyles';
import { Theme } from '../../theme';
import { BasePanelProps, PanelColor } from './types';

export const processPanelColor = (theme: Theme, panelColor: PanelColor): PanelColor =>
  typeof panelColor === 'string' ? panelColor : panelColor({ theme });

export const getPanelColor = (theme: Theme, panelColor?: PanelColor): PanelColor =>
  panelColor ? processPanelColor(theme, panelColor) : 'transparent';

export const borderPx = 1;

const insetShadow = (
  theme: Theme,
  lightColor: PanelColor | undefined
): FlattenInterpolation<ThemeProps<Theme>> => css`
  z-index: -2;
  background-color: ${getPanelColor(theme, lightColor)};
  ::before {
    z-index: -1;
    background-color: ${theme.colors.neutral08};
    position: absolute;
    top: 8px;
    bottom: 8px;
    left: 8px;
    right: 8px;
    border-radius: 8px;
    content: '';
  }
`;

export const panelContainer = css<BasePanelProps>`
  // Since we are modifying the z-index of nested items, this is needed to ensure this
  // behaves properly with other components
  position: relative;
  z-index: 0;
  border-radius: ${({ theme }) => theme.cardRadius};
`;

export const insetShadowOrSolidBackground = css<BasePanelProps>`
  ${({ colors, borderShadows, theme }) =>
    css`
      ${borderShadows?.displayInset
        ? insetShadow(theme, colors?.lightColor)
        : css`
            background-color: ${theme.colors.neutral08};
          `}
    `}
`;

export const outsetShadow = css`
  box-shadow: ${boxShadow};
`;

export const coloredBorder = css<BasePanelProps>`
  ${({ colors, theme }) =>
    css`
      border: ${borderPx}px solid ${getPanelColor(theme, colors?.primaryColor)};
    `}
`;

export const defaultBorder = css`
  border: ${borderPx}px solid ${({ theme }) => theme.colors.neutral04};
`;
